<template>
  <div class="header">
    <div style="padding: 0 20px">
      <div class="d-flex justify-content-between align-items-center">
        <div class="left">
          <i class="fa fa-bars bars" @click="toggleSidebar"></i>
          <!-- <img class="logo1" src="../assets/image/LogoSuzuya.png" /> -->
        </div>
        <div class="right">
          <div class="profile" @click="toggleProfile(true)">
            <div class="d-flex align-items-center">
              <img src="../assets/image/user.png" alt="" />
              <p>{{ userData ? userData.username : "" }}</p>
              <p><i class="fas fa-angle-down"></i></p>
            </div>
            <div>
              <ul
                class="profile-link"
                :class="[toggleStatus ? 'show-profile' : '']"
              >
                <!-- <li>
                  <div class="dark-mode">
                    <div class="form-check form-switch">
                      <input
                        class="form-check-input active"
                        type="checkbox"
                        id="flexSwitchCheckChecked"
                        v-model="isMode"
                      />
                      <label
                        class="form-check-label"
                        for="flexSwitchCheckChecked"
                        >Light</label
                      >
                    </div>
                  </div>
                </li> -->
                <!-- <li><div class="divider"></div></li> -->
                <li
                  @click="setDetailUser(userData.usercode)"
                  data-bs-toggle="modal"
                  data-bs-target="#modaDetailUser"
                >
                  <router-link to="#"
                    ><i class="fas fa-user icon-left"></i> Profile</router-link
                  >
                </li>
                <li @click="logout">
                  <router-link to="#"
                    ><i class="fas fa-sign-out-alt icon-left"></i>
                    Keluar</router-link
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <UserDetailComponent :userDetail="userDetail" />
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import UserDetailComponent from "@/components/users/UserDetailComponent.vue";
export default {
  data() {
    return {
      toggleStatus: false,
    };
  },
  components: {
    UserDetailComponent,
  },
  computed: {
    ...mapState({
      userData: (state) => state.Auth.userData,
      userDetail: (state) => state.Users.userDetail,
    }),
  },
  methods: {
    toggleProfile() {
      this.toggleStatus = !this.toggleStatus;
    },
    setDetailUser(n) {
      this.detailUser(n);
      this.readListCompany();
    },
    ...mapActions({
      detailUser: "Users/readOne",
      logout: "Auth/logout",
      readListCompany: "Company/readList",
      toggleSidebar: "Auth/toggleSidebar",
    }),
  },
};
</script>
<style scoped>
.header {
  background: var(--bg-color);
  padding-top: 8px;
  padding-bottom: 8px;
  z-index: 201;
  box-shadow: 4px 4px 16px rgba(92, 92, 92, 0.1);
}
.header .logo1 {
  width: 115px;
}
.header .bars {
  cursor: pointer;
  color: var(--text-one);
}
.header .profile {
  position: relative;
  padding: 2px 10px 2px 2px;
  border-radius: 50px;
  cursor: pointer;
  box-sizing: border-box;
}
.header .profile:hover {
  background: var(--hover-one);
}
.header .profile img {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  object-fit: cover;
  cursor: pointer;
}
.header .profile p {
  padding: 0 5px 0 5px !important;
  font-size: 12px;
  font-weight: 400;
  color: var(--text-one);
}
.header .profile .profile-link {
  background-color: var(--bg-color);
  position: absolute;
  top: calc(100% + 25px);
  right: 0;
  padding: 10px !important;
  box-shadow: 4px 4px 16px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  width: 180px;
  opacity: 0;
  pointer-events: none;
  transition: all 0.3s ease;
  z-index: 999;
  border: 1px solid var(--border-one);
}
.header .profile .profile-link li a {
  padding: 5px 10px !important;
  display: flex;
  grid-gap: 10px;
  font-size: 12px;
  color: var(--text-one);
  align-items: center;
  transition: all 0.3s ease;
  font-weight: 400;
}
.header .profile .profile-link li a:hover {
  cursor: pointer;
  background-color: var(--hover-one);
  border-radius: 5px;
}
.header .profile .profile-link.show-profile {
  opacity: 1;
  pointer-events: visible;
  top: calc(100% + 10px);
}

.header .icon-left {
  width: 12px;
  font-size: 12px;
  color: rgb(25, 115, 226);
}

@media (max-width: 576px) {
  .header .profile p {
    display: none;
  }
  .header .profile {
    padding: 0;
  }
}
</style>
